import React, { useMemo, useRef, useState } from 'react';
import {
  Grid,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide
} from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import PF from "../_Services/publicFunction";
import { useSnackbar } from "notistack";
import Qs from "qs";
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 🔹 Grid CSS 優化
const gridWrapTextStyle = `
.ag-theme-alpine .wrap-text {
  white-space: pre-wrap !important;  /* 保留換行符號並自動換行 */
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
  padding: 4px 6px;
}
`;
const styleTag = document.createElement("style");
styleTag.innerHTML = gridWrapTextStyle;
document.head.appendChild(styleTag);

// 🔹 自動格式化文字換行（含句號換行）
const formatValueForTextarea = (value) => {
  if (!value) return "";

  return value
    .replace(/\r\n/g, '\n')         // Windows 換行
    .replace(/\r/g, '\n')           // 舊 Mac 換行
    .replace(/\\n/g, '\n')          // 字串中的 \n
    .replace(/(\d+)\./g, '\n$1.')  // 數字序號換行
    .replace(/；/g, ';\n')          // 中文分號換行
    .replace(/;/g, ';\n')           // 英文分號換行
    .replace(/。/g, '。\n')          // 中文句號換行
    .replace(/\.(?=\s|$)/g, '.\n')  // 英文句號換行
    .replace(/\n+/g, '\n')          // 合併連續換行
    .trim();                         // 去掉前後多餘換行
};

const QueryLostitem = () => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const gridRef = useRef();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [todayList, setTodayList] = useState([]);
  const [historyList, setHistoryList] = useState([]);

  // Dialog states
  const [editOpen, setEditOpen] = useState(false);
  const [editRow, setEditRow] = useState({});
  const [editSaving, setEditSaving] = useState(false);
  const [originalEditValue, setOriginalEditValue] = useState('');

  const columnDefs = [
    { field: 'SpecialCheckDate', headerName: "報到日期", width: 150, tooltipField: 'SpecialCheckDate' },
    { field: 'UserName', headerName: "姓名", width: 150, tooltipField: 'UserName' },
    { field: 'UserID', headerName: "身分證號", width: 150, tooltipField: 'UserID' },
    { field: 'BarCodeStr', headerName: "條碼號", width: 150, tooltipField: 'BarCodeStr' },
    { field: 'itemno', headerName: "檢驗項目", width: 150, tooltipField: 'itemno' },
    { field: 'ItemName', headerName: "項目名稱", width: 250, tooltipField: 'ItemName' },
    { field: 'CheckCategory', headerName: "類別", width: 150, tooltipField: 'CheckCategory' },
    {
      field: 'Value',
      headerName: "數值",
      width: 270,
      tooltipField: 'Value',
      editable: true,
      cellEditor: 'agTextCellEditor',
      cellClass: 'wrap-text',
      autoHeight: true,
    },
    { field: 'Err', headerName: "異常值", width: 130, tooltipField: 'Err' },
  ];

  const defaultColDef = { resizable: true, sortable: true, filter: true };

  const onChange = (dates, dateStrings) => {
    setStartDate(dateStrings[0]);
    setEndDate(dateStrings[1]);
  };

  // 🔹 API 查詢
  const handleQuery = () => {
    if (!startDate || !endDate) {
      enqueueSnackbar('請輸入日期', { variant: 'error', style: { whiteSpace: 'pre-line' } });
      return;
    }
    setOpen(true);
    PF.instance({
      method: "post",
      url: PF.url2 + "/Minmax/GetQueryLostitem",
      data: Qs.stringify({ Action: "1", parameter: { startDate, endDate } }),
      headers: { token: sessionStorage.token }
    })
      .then(response => {
        setOpen(false);
        const { TotalRecord, rows, rows2 } = response.data;
        if (TotalRecord < 0) {
          enqueueSnackbar("錯誤", { variant: 'error' });
        } else if (TotalRecord === 0) {
          enqueueSnackbar("沒有資料", { variant: 'warning' });
          setTodayList([]);
          setHistoryList([]);
        } else {
          enqueueSnackbar(`成功: 找到 ${TotalRecord} 筆記錄`, { variant: 'success' });
          setTodayList(rows);
          setHistoryList(rows2);
        }
      })
      .catch(err => {
        setOpen(false);
        enqueueSnackbar("查詢失敗", { variant: "error" });
      });
  };

  // 🔹 Dialog 編輯
  const onCellDoubleClicked = (params) => {
    if (params.colDef?.field === "Value") {
      const formattedValue = formatValueForTextarea(params.data.Value);
      setEditRow({ ...params.data, Value: formattedValue });
      setOriginalEditValue(formattedValue);
      setEditOpen(true);
    }
  };

  const callUpdateApi = async ({ BarCodeStr, ItemNo, Value, Err }) => {
    const payload = { Action: "UPDATE", parameter: { BarCodeStr, ItemNo, Value, Err } };
    return PF.instance({
      method: "post",
      url: PF.url2 + "/Minmax/UpdateLostItemValue",
      data: Qs.stringify(payload),
      headers: { token: sessionStorage.token }
    });
  };

  const onCellValueChanged = async (params) => {
    if (!params.colDef || params.colDef.field !== "Value") return;

    const updated = { ...params.data, Value: formatValueForTextarea(params.data.Value) };
    const oldValue = params.oldValue;

    if (!updated.BarCodeStr || !updated.itemno) {
      enqueueSnackbar("缺少 BarCodeStr 或 ItemNo，無法更新", { variant: "error" });
      return;
    }

    try {
      setOpen(true);
      await callUpdateApi({
        BarCodeStr: updated.BarCodeStr,
        ItemNo: updated.itemno,
        Value: updated.Value,
        Err: updated.Err || ''
      });

      enqueueSnackbar("更新成功", { variant: "success" });

      setTodayList(prev => prev.map(r =>
        r.BarCodeStr === updated.BarCodeStr && r.itemno === updated.itemno
          ? updated
          : r
      ));
    } catch (err) {
      enqueueSnackbar("更新失敗，自動還原原本值", { variant: "error" });
      setTodayList(prev => prev.map(r =>
        r.BarCodeStr === updated.BarCodeStr && r.itemno === updated.itemno
          ? { ...r, Value: oldValue }
          : r
      ));
      console.error(err);
    } finally {
      setOpen(false);
    }
  };

  const handleDialogSave = async () => {
    if (!editRow?.BarCodeStr || !editRow?.itemno) {
      enqueueSnackbar("資料不完整，無法儲存", { variant: "error" });
      return;
    }

    setEditSaving(true);
    try {
      await callUpdateApi({
        BarCodeStr: editRow.BarCodeStr,
        ItemNo: editRow.itemno,
        Value: editRow.Value,
        Err: editRow.Err || ''
      });

      enqueueSnackbar("修改成功！", { variant: "success" });
      setEditOpen(false);
      setTodayList(prev => prev.map(r =>
        r.BarCodeStr === editRow.BarCodeStr && r.itemno === editRow.itemno
          ? { ...r, Value: editRow.Value }
          : r
      ));
    } catch (err) {
      enqueueSnackbar("修改失敗，自動還原原本值", { variant: "error" });
      setTodayList(prev => prev.map(r =>
        r.BarCodeStr === editRow.BarCodeStr && r.itemno === editRow.itemno
          ? { ...r, Value: originalEditValue }
          : r
      ));
      setEditRow(prev => ({ ...prev, Value: originalEditValue }));
      console.error(err);
    } finally {
      setEditSaving(false);
    }
  };

  const onDialogKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleDialogSave();
    }
  };

  return (
    <>
      <RangePicker onChange={onChange} format="YYYY/MM/DD" style={{ marginBottom: '8px' }} />
      <Button onClick={handleQuery} variant="contained" style={{ marginLeft: '5px' }}>查詢</Button>

      <Grid container spacing={0}>
        <Grid item xs={12} md={6} textAlign="right">
          <div style={{ width: '100%', height: '100%' }}>
            <div className="ag-theme-alpine" style={{ height: '93vh', width: '97vw' }}>
              <AgGridReact
                ref={gridRef}
                rowData={todayList}
                columnDefs={columnDefs}
                rowSelection={'multiple'}
                defaultColDef={defaultColDef}
                enableRangeSelection={true}
                enableStatusBar={true}
                onCellDoubleClicked={onCellDoubleClicked}
                onCellValueChanged={onCellValueChanged}
                getRowHeight={(params) => {
                  if (params.data?.Value) {
                    const lines = params.data.Value.split('\n').length;
                    return Math.max(30, lines * 22);
                  }
                  return 30;
                }}
              />
            </div>
          </div>
        </Grid>
      </Grid>

      {/* Dialog */}
      <Dialog
        open={editOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setEditOpen(false)}
        PaperProps={{
          sx: { borderRadius: "12px", width: "40vw", maxWidth: "600px", minHeight: "350px", maxHeight: "40vh", boxShadow: 6, p: 2 }
        }}
      >
        <DialogTitle sx={{ fontSize: 20, fontWeight: '700', textAlign: 'center' }}>修改數值</DialogTitle>
        <DialogContent sx={{ px: 3, py: 2 }}>
          <TextField
            label="Value（數值）"
            value={editRow.Value || ""}
            onChange={(e) => setEditRow({ ...editRow, Value: e.target.value })}
            onPaste={(e) => {
              e.preventDefault();
              const paste = e.clipboardData.getData('text');
              const formatted = formatValueForTextarea(paste);
              setEditRow(prev => ({ ...prev, Value: formatted }));
            }}
            fullWidth
            autoFocus
            size="small"
            multiline
            minRows={5}
            maxRows={15}
            onKeyDown={onDialogKeyDown}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: "10px", overflow: 'auto' } }}
            helperText={editRow.itemno || editRow.BarCodeStr
              ? `ItemNo: ${editRow.itemno || ''}\nBarCodeStr: ${editRow.BarCodeStr || ''}`
              : ''}
            FormHelperTextProps={{ sx: { whiteSpace: 'pre-line', fontSize: '13px' } }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setEditOpen(false)} variant="outlined" sx={{ textTransform: 'none', borderRadius: 2 }} disabled={editSaving}>取消</Button>
          <Button onClick={handleDialogSave} variant="contained" sx={{ textTransform: 'none', borderRadius: 2, px: 3 }} disabled={editSaving}>
            {editSaving ? '儲存中...' : '儲存'}
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default QueryLostitem;
